import {
  getEmployeeById,
  getAllEmployees,
} from "@/common/services/employee.api";
import { uploadSignedDocumentInventoryManagement } from "@/common/services/Inventory-management.api";
import { getProductByCode } from "@/common/services/product.api";
import { IEmployee } from "@/types/employee.type";
import { IinventoryManagement } from "@/types/inventory-management.type";
import { useEffect, useState } from "react";

type EmployeersResult = {
  ok: boolean;
  data: IEmployee[];
  totalItems: number;
} | null;

export const useEmployeers = () => {
  const [data, setData] = useState<EmployeersResult>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<unknown | null>(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const result = await getAllEmployees();
      if (result.ok) {
        setData({
          ...result,
          totalItems: result.data?.length || 0,
        });
      }
    } catch (err) {
      setError(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data: data?.data,
    loading,
    error,
  };
};

export const fetchAssetTermsDocumentData = async ({ inventoryManagement }) => {
  const { employeerId, assetCode } = inventoryManagement;

  const employeeData = await getEmployeeById(employeerId);
  const productData = await getProductByCode(assetCode);

  return {
    employeer: employeeData.data,
    inventory: inventoryManagement,
    product: productData.data,
  };
};

interface ApiResponse {
  ok: boolean;
  message?: string;
  data?: IinventoryManagement;
}

export const uploadSignedDocument = async (
  inventoryId: string,
  file: File,
): Promise<ApiResponse> => {
  const fileBase64 = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  return await uploadSignedDocumentInventoryManagement({
    inventoryId,
    file: fileBase64,
    fileName: file.name,
  });
};
